import _ from 'lodash';

export function simpleStateMerge(state: any, { payload }: any) {
  return _.merge({}, state, payload);
}
